export const SHOW_BREAKDOWN_ICON =
  'src/PaymentBreakdownIcon/SHOW_BREAKDOWN_ICON'
